<template>
    <v-app>
        <!-- <v-app-bar style="background-color: white;" :style='[$vuetify.breakpoint.xs ? {"width":"60px"} : {"width":"120px"}]' rounded="true" app collapse>
            <v-btn style="color:black;" icon v-if="!$vuetify.breakpoint.xs">
                <v-icon v-if="toggleMini" @click="toggleMini = !toggleMini">mdi-chevron-right-circle</v-icon>
                <v-icon v-else @click="toggleMini = !toggleMini">mdi-chevron-left-circle</v-icon>
            </v-btn>

            <v-btn icon>
                <v-avatar size="36">
                    <img :src="userProfile.profilePicUrl" />
                </v-avatar>
            </v-btn>
        </v-app-bar> -->
        <v-navigation-drawer
            id="sidebar"
            style="background-color:#1b355b;border-radius: 0px 0px 5px 0px;"
            v-model="sidebarMenu"
            app
            floating
            :permanent="sidebarMenu"
            :mini-variant.sync="mini"
            :mini-variant-width="70"
        >
            <v-list :style='[mini ? {"padding":"0%", "margin-top":"5px", "margin-bottom": "5px"}: {"padding":"7%"}]'>
                <v-list-item>
                    <v-img contain src="../assets/images/aawaz-logo-white.png"></v-img>
                </v-list-item>
            </v-list>

            <v-list nav style="padding:0;color:white;">
                <div v-if="admin">
                    <v-list-item
                        v-for="item in adminItems"
                        :key="item.title"
                        link
                        :to="item.href"
                        style="text-decoration:none; margin:0;color:white !important"
                        :style='[!mini ? {"padding-left":"30px"} : {"padding": "0px"}]'
                    >
                        <v-list-item-icon>
                            <v-icon color="white">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </div>
                <div v-if="teacher && !admin">
                    <v-list-item
                        v-for="item in teacherItems"
                        :key="item.title"
                        link
                        :to="item.href"
                        style="text-decoration:none; margin:0;color:white !important"
                        :style='[!mini ? {"padding-left":"30px"} : {"padding": "0px"}]'
                    >
                        <v-list-item-icon>
                            <v-icon color="white">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </div>
                <div v-if="!admin && !teacher">
                    <v-list-item
                        v-for="item in studentItems"
                        :key="item.title"
                        link
                        :to="item.href"
                        style="text-decoration:none; margin:0;color:white !important"
                        :style='[!mini ? {"padding-left":"30px"} : {"padding": "0px"}]'
                    >
                        <v-list-item-icon>
                            <v-icon color="white">{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </div>
                <v-footer absolute style="background:transparent; padding:0;">
                    <v-list-item
                        :style='[!mini ? {"padding-left":"30px"} : {"padding": "0px"}]'
                        @click="logout"
                        style="text-decoration:none; margin:0;color:white !important"
                    >
                        <v-list-item-icon>
                            <v-icon color='white'>mdi-logout-variant</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>Logout</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-footer>
            </v-list>
        </v-navigation-drawer>
        <v-main>
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");

export default {
    data: () => ({
    sidebarMenu: true,
    toggleMini: false,
    adminItems: [
      { title: "Dashboard", href: "/home", icon: "mdi-collage" },
      { title: "Chat", href: "/chat", icon: "mdi-forum" },
      { title: "Tools", href: "/admin", icon: "mdi-wrench" },
      { title: "Extras", href: "/extras", icon: "mdi-buffer" },
      { title: "Profile", href: "/profile", icon: "mdi-account-circle" }
    ],
    studentItems: [
      { title: "Dashboard", href: "/home", icon: "mdi-collage" },
      { title: "Chat", href: "/chat", icon: "mdi-forum" },
      { title: "Reports", href: "/reports", icon: "mdi-book" },
      { title: "Assignments", href: "/assignments", icon: "mdi-file-edit" },
      { title: "Gallery", href: "/gallery", icon: "mdi-folder-image" },
      { title: "Profile", href: "/profile", icon: "mdi-account-circle" }
    ],
    teacherItems: [
      { title: "Dashboard", href: "/home", icon: "mdi-collage" },
      { title: "Chat", href: "/chat", icon: "mdi-forum" },
      { title: "Tools", href: "/admin", icon: "mdi-wrench" },
      { title: "Profile", href: "/profile", icon: "mdi-account-circle" }
    ],
  }),
    computed: {
        ...mapState(["teacher", "admin", "userProfile"]),
        mini() {
            return this.$vuetify.breakpoint.smAndDown || this.toggleMini;
        },
    },
    methods: {
        logout() {
            fb.auth
                .signOut()
                .then(() => {
                    this.$store.dispatch("clearData");
                    this.$router.push("/login");
                })
                .catch(err => {
                    console.log(err);
                });
        },
        toggleTheme() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
        }
    }
};
</script>

<style scoped>
</style>
